import * as React from 'react';

// eslint-disable-next-line @wyz/module/no-relative-import
import { AnalyticsContext } from './contexts';
import { useMemo } from 'react';
import { IAnalyticsContext, IAnalyticsEvent } from '~/common/types';
// eslint-disable-next-line @wyz/module/no-relative-import
import { useConfig } from './config-provider';
import { User } from 'oidc-client-ts';
import { isNil } from 'lodash-es';

export function AnalyticsProvider(props: React.PropsWithChildren) {
  const config = useConfig();

  const context = useMemo(() => {
    const sendEvent = (
      user: User | null | undefined,
      data: IAnalyticsEvent,
    ) => {
      if (isNil(user)) {
        return;
      }

      // eslint-disable-next-line prefer-const
      let { type, backend, ...payload } = data;

      if (isNil(backend)) {
        backend = 'event_bridge';
      }

      if (backend === 'event_bridge') {
        payload = {
          ...payload,
          type,
        };
      }

      fetch(
        `${config.apiUrl}/tenants/api/wtb/tenants/${config.tenantCode}/analytics/${type}?backend=${backend}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user?.access_token}`,
          },
          body: JSON.stringify(payload),
        },
      ).catch(() => {});
    };

    return {
      sendEvent: (user: User | null | undefined, data: IAnalyticsEvent) =>
        sendEvent(user, data),
    } satisfies IAnalyticsContext;
  }, [config]);

  return (
    <AnalyticsContext.Provider value={context}>
      {props.children}
    </AnalyticsContext.Provider>
  );
}

export const useAnalytics = () => {
  const context = React.useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error('useAnalytics must be used within a AnalyticsContext');
  }
  return context;
};
